module.exports = __webpack_public_path__ + "static/img/demand-form.45b14401.png";